import React, { useState } from "react";
import "./header.css";
import logo from "../../assets/images/Wordmark.svg";
import { setLanguage } from "react-multi-lang";
import { useDispatch, useSelector } from "react-redux";
import { setLangDetails, setLocale } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";

const Header = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { languageList } = useSelector((state) => state.lng);
  const [open, setOpen] = useState(false);
  const onClick = (value) => {
    setOpen(false);
    setLanguage(value.code);
    dispatch(setLangDetails(value));
    dispatch(setLocale(value.locale));
    history.push(`/?lang:${value.code}`);
  };
  return (
    <header>
      <div className="logo">
        <img src={logo} alt="" />
      </div>

      <div className="language" onClick={() => setOpen(!open)}>
        Select language
      </div>
      {open && (
        <div className="language-list">
          {languageList.map((item) => {
              if(item.code==='ara')
              {
                  return  null
              }
              else{
            return (
              <div onClick={() => onClick(item)} key={item.id}>
                {item.name}
              </div>
            );}
          })}
        </div>
      )}
    </header>
  );
};
export default Header;
